import { ListaMoraPolicy } from "./ListaMoraPolicy"

export const listaMoraPolicy = new ListaMoraPolicy()